<div class="breadcrumb-container text-7xl">
    <p-breadcrumb [model]="breadcrumbsService.breadcrumbs" class="text-7xl s-s-l-justifyTopBar"></p-breadcrumb>
</div>